// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__zX9Ia","messages":"Chat_messages__kwbUB","dateDivider":"Chat_dateDivider__u1Fyr"};